import {Product} from 'components/customer/Product/entity/Product';
import {ProductApi} from 'components/customer/Product/entity/ProductApi';
import {mapProduct} from 'components/customer/Product/helpers/mapProduct';
import {mapMaterial} from 'components/customer/Materials/helper/materialHelper';
import {normalizeProductDrawers} from 'hooks/Product/helpers/normalizeDrawerValues';
import {Template3D} from 'components/customer/RoomPlanner/types';
import {mapJobCabinetAppliances} from 'components/customer/Product/Appliance/helpers/mapAppliance';

type ProductApiWithTemplate = ProductApi & {
    template_3d?: Template3D;
};

export const mapJobCabinetsToProducts = (
    jobCabinets: ProductApiWithTemplate[] = []
): Product[] =>
    jobCabinets
        .map((cabinet) => {
            const product = mapProduct(cabinet);
            const productWithAppliances = mapJobCabinetAppliances(product);

            return {
                ...productWithAppliances,
                ...(cabinet.template_3d
                    ? {template_3d: cabinet.template_3d}
                    : {}),
                extMaterial: mapMaterial(product.ext_material),
                carcMaterial: mapMaterial(product.carc_material),
            };
        })
        .map((product) => normalizeProductDrawers(product))
        .sort((a, b) => a.room_cab_number - b.room_cab_number);
